const passwordHelper = t => password => {
  if (password === undefined || password === null) return null;
  if (password.toLowerCase() === password) return t("auth.password_requires_uppercase");
  if (!/\d/.test(password)) return t("auth.password_requires_number");
  if (password.toUpperCase() === password) return t("auth.password_requires_lowercase");
  if (password.length < 8) return t("auth.password_requires_8_char");
  return null;
}

export { passwordHelper }